import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["button", "videoDiv"];

    playVideo() {
        // Меняем фон контроллера
        this.element.style.backgroundImage = "none";
        this.element.style.backgroundColor = "black";

        // Удаляем кнопку, если она есть
        if (this.hasButtonTarget) {
            this.buttonTarget.remove();
        }

        // Показываем div с видео
        this.videoDivTarget.classList.remove("hidden");
        this.videoDivTarget.classList.add("flex");

        // Находим iframe и обновляем src с параметром t=0
        const iframe = this.videoDivTarget.querySelector("iframe");
        if (iframe) {
            const src = new URL(iframe.src);
            src.searchParams.set("autoplay", "true");
            src.searchParams.set("muted", "0");
            src.searchParams.set("t", "0"); // Сбрасываем видео на начало
            iframe.src = src.toString();
        }
    }
}
